import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
  Chip,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Group } from "../../lib/types";

interface GroupCardProps {
  group: Group;
}

// Capitalize first letter of a string
const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

const GroupCard: React.FC<GroupCardProps> = ({ group }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/groups/${group.id}`);
  };

  const membersTooltip =
    group.memberNames && group.memberNames.length > 0
      ? group.memberNames.join(", ")
      : "No members";

  return (
    <Card elevation={0} sx={{ borderRadius: 1 }}>
      <CardActionArea onClick={handleClick}>
        <CardContent>
          <Stack spacing={2}>
            <Stack spacing={0.5}>
              <Typography variant="h6" fontWeight={700}>
                {group.name}
              </Typography>
              <Typography color="text.secondary" variant="body2">
                {group.description || "No description yet."}
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
              <Chip
                label={capitalize(group.type)}
                size="small"
                variant="outlined"
              />
              {group.role && (
                <Chip
                  label={capitalize(group.role)}
                  size="small"
                  color={group.role === "owner" ? "primary" : "default"}
                />
              )}
              {typeof group.memberCount === "number" && (
                <Tooltip title={membersTooltip} arrow placement="top">
                  <Chip
                    label={`${group.memberCount} Members`}
                    size="small"
                    variant="outlined"
                  />
                </Tooltip>
              )}
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default GroupCard;
